import {firebaseAuth} from '../../api/firebase';

export const getAuthUser = () => {
  return firebaseAuth.currentUser;
};
